'use client';

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

// Backend integration point: replace with /api/collection/brand-distribution
const brandData = [
  { brand: 'Fender', count: 3 },
  { brand: 'Gibson', count: 2 },
  { brand: 'PRS', count: 2 },
  { brand: 'Martin', count: 2 },
  { brand: 'Taylor', count: 1 },
  { brand: 'Ibanez', count: 1 },
  { brand: 'Gretsch', count: 1 },
];

function CustomTooltip({ active, payload, label }: { active?: boolean; payload?: { value: number }[]; label?: string }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg px-3 py-2 shadow-modal text-sm">
      <p className="font-600 text-foreground">{label}</p>
      <p className="text-muted-foreground">{payload[0].value} guitar{payload[0].value !== 1 ? 's' : ''}</p>
    </div>
  );
}

const BAR_COLORS = ['#2563EB', '#3B82F6', '#60A5FA', '#93C5FD', '#BFDBFE', '#DBEAFE', '#EFF6FF'];

export default function BrandDistributionChart() {
  return (
    <div className="bg-card rounded-2xl p-5 shadow-card border border-border h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-sm font-700 text-foreground">Brand Distribution</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Guitars per manufacturer</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={brandData} barSize={24} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
          <XAxis
            dataKey="brand"
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)', fontFamily: 'var(--font-sans)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)', fontFamily: 'var(--font-sans)' }}
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'var(--muted)', opacity: 0.5 }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]}>
            {brandData.map((entry, index) => (
              <Cell key={`brand-cell-${entry.brand}`} fill={BAR_COLORS[index % BAR_COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}